export const consort_highlight_color = {
	"1a":"#88FF88",
	"1b":"#88FF88",
	"2": "#CCAAFF",
	"3": "#88FFFF",
	"4": "#88FFFF",
	"5a": "#88FFFF",
	"5b": "#88FFFF",
	"6": "#88FFFF",
	"7": "#88FFFF",
	"8": "#88FFFF",
	"9" : "#88FFFF",
	"10" : "#88FFFF",
	"11" : "#88FFFF",
	"12a": "#88FFFF",
	"12b" : "#88FFFF",
	"13": "#bbff44",
	"14" : "#bbff44",
	"15" : "#bbff44",
	"16a" : "#bbff44",
	"16b" : "#bbff44",
	"17a" : "#bbff44",
	"17b" : "#bbff44",
	"18" : "#bbff44",
	"19" : "#bbff44",
	"20a" : "#AACCFF",
	"20b" : "#AACCFF",
	"21a" : "#AACCFF",
	"21b" : "#AACCFF",
	"21c": "#AACCFF",
	"21d": "#AACCFF",
	"22a" : "#AACCFF",
	"22b" : "#AACCFF",
	"23a" : "#FFAACC",
	"23b" : "#FFAACC",
	"24a" : "#FFAACC",
	"24b" : "#FFAACC",
	"25" : "#FFAACC",
	"26" : "#FFAACC",
	"27" : "#FFAACC",
	"28" : "#FFAACC",
	"29" : "#FFAACC",
	"30" : "#FFAACC",
}

export const consort_label_color = {
	"1a": "#009c00",
	"1b": "#009c00",
	"2": "#4400aa",
	"3": "#009c9c",
	"4": "#009c9c",
	"5a":  "#009c9c",
	"5b": "#009c9c",
	"6": "#009c9c",
	"7": "#009c9c",
	"8": "#009c9c",
	"9" : "#009c9c",
	"10" :"#009c9c",
	"11" :"#009c9c",
	"12a ":"#009c9c",
	"12b" :"#009c9c",
	"13":"#528100",
	"14" :"#528100",
	"15" :"#528100",
	"16a" :"#528100",
	"16b" :"#528100",
	"17a" :"#528100",
	"17b" :"#528100",
	"18" :"#528100",
	"19" :"#528100",
	"20a" :"#805566",
	"20b" :"#805566",
	"21a" :"#805566",
	"21b" :"#805566",
	"21c" :"#805566",
	"21d" :"#805566",
	"22a" :"#805566",
	"22b" :"#805566",
	"23a" :"#805566",
	"23b" :"#805566",
	"24a" :"#805566",
	"24b" :"#805566",
	"24" :"#805566",
	"25" :"#805566",
	"26" :"#805566",
	"27" :"#805566",
	"28" :"#805566",
	"29" :"#805566",
	"30" :"#805566",
}

export const spirit_highlight_color = {
	"1a": "#AACCFF",
	"1b": "#AACCFF",
	"2": "#AACCFF",
	"3a": "#AACCFF",
	"3b": "#AACCFF",
	"3c": "#AACCFF",
	"3d": "#AACCFF",
	"4": "#AACCFF",
	"5":  "#AACCFF",
	"6": "#CCAAFF",
	"7a": "#CCAAFF",
	"7b": "#CCAAFF",
	"8": "#CCAAFF",
	"9a" : "#88FFFF",
	"9b" : "#88FFFF",
	"10" : "#88FFFF",
	"11" : "#88FFFF",
	"12": "#88FFFF",
	"13": "#88FFFF",
	"14a" : "#88FFFF",
	"14b" : "#88FFFF",
	"15a" : "#88FFFF",
	"15b" : "#88FFFF",
	"15c" : "#88FFFF",
	"15d" : "#88FFFF",
	"16" : "#88FFFF",
	"17" : "#88FFFF",
	"18" : "#88FFFF",
	"19" : "#88FFFF",
	"20" : "#88FFFF",
	"21a" : "#88FFFF",
	"21b" : "#88FFFF",
	"22" : "#88FFFF",
	"23" : "#88FFFF",
	"24a" : "#bbff44",
	"24b" : "#bbff44",
	"24c" : "#bbff44",
	"25a" : "#bbff44",
	"25b" : "#bbff44",
	"26" : "#bbff44",
	"27a" : "#bbff44",
	"27b" : "#bbff44",
	"27c" : "#bbff44",
	"27d" : "#bbff44",
	"28a" : "#bbff44",
	"28b" : "#bbff44",
	"29" : "#bbff44",
	"30" : "#bbff44",
	"31" : "#bbff44",
	"32a" : "#FFAACC",
	"32b" : "#FFAACC",
	"33" : "#FFAACC",
	"34" : "#FFAACC",
}

export const spirit_label_color = {
	"1a": "#0044aa",
	"1b": "#0044aa",  
	"2": "#0044aa",   
	"3a": "#0044aa",
	"3b": "#0044aa",
	"3c": "#0044aa",
	"3d": "#0044aa",
	"4": "#0044aa",
	"5": "#0044aa",   
	"6": "#4400aa",   
	"7a": "#4400aa", 
	"7b": "#4400aa",
	"8": "#4400aa",
	"9a": "#009c9c",  
	"9b": "#009c9c",
	"10": "#009c9c",
	"11": "#009c9c",  
	"12": "#009c9c",
	"13": "#009c9c",
	"14a": "#009c9c", 
	"14b": "#009c9c",
	"15a": "#009c9c", 
	"15b": "#009c9c",
	"15c": "#009c9c",
	"15d": "#009c9c",
	"16": "#009c9c",  
	"17": "#009c9c",  
	"18": "#009c9c",  
	"19": "#009c9c",
	"20": "#009c9c",  
	"21a": "#009c9c",
	"21b": "#009c9c",
	"22": "#009c9c",
	"23": "#009c9c",
	"24a": "#528100", 
	"24b": "#528100",
	"24c": "#528100",
	"25a": "#528100",
	"25b": "#528100",
	"26": "#528100",  
	"27a": "#528100", 
	"27b": "#528100",
	"27c": "#528100", 
	"27d": "#528100",
	"28a": "#528100",
	"28b": "#528100",
	"29": "#528100",
	"30": "#528100",
	"31": "#528100", 
	"32a": "#0044aa",
	"32b": "#0044aa", 
	"33": "#0044aa",  
	"34": "#0044aa",  
}
